import { NodeTextPosition } from './NodeTextPosition';

/** IE Insanity for resolving cursor positions into a node+offset */
export class IEInsanity {
    private static getUsableAnchorElement(element: Element) {
        while (element.matches('.js-highlight')) {
            // When selection accidently comes inside a highlight, the calculations are incorrect.
            element = element.parentNode as Element;
        }
        return element;
    }

    /** element at view X/Y */
    public readonly element: Element;

    /* tslint:disable */
    private _iterations = 0;
    /* tslint:enable */
    private readonly _characters: string;
    private readonly _textRange: IERange;

    public constructor(
        /** X position of cursor within the viewport */
        public readonly viewX: number,
        /** Y position of cursor within the viewport */
        public readonly viewY: number,
    ) {
        this.element = IEInsanity.getUsableAnchorElement(document.elementFromPoint(viewX, viewY));
        this._textRange = document.body.createTextRange();
        this._textRange.moveToElementText(this.element);
        this._characters = this._textRange.text;
    }

    /** approaches by taking large steps and returns an exact line or beyond the view X/Y */
    public calcTextPositionRough(): NodeTextPosition {
        const stepLarge = 100;
        for (let idxCharacter = 0; idxCharacter < this._characters.length; idxCharacter += stepLarge) {
            this._iterations++;
            const rects = this.boundsOfCharacter(idxCharacter);
            if (!rects) { continue; }
            for (let j = 0, jj = rects.length; j < jj; j++) {
                if (rects[j].top <= this.viewY) {
                    return new NodeTextPosition(this.element, Math.max(0, idxCharacter - stepLarge));
                }
            }
        }
    }

    /** searches a character which contains view X/Y */
    public calcTextPositionExact(idxStart: number): NodeTextPosition {
        for (let idxCharacter = idxStart; idxCharacter < this._characters.length; idxCharacter++) {
            this._iterations++;
            const rects = this.boundsOfCharacter(idxCharacter);
            if (!rects) { continue; }
            for (let j = 0, jj = rects.length; j < jj; j++) {
                if (this.inside(rects[j])) {
                    return new NodeTextPosition(this.element, this.getCrossBrowserOffset(idxCharacter));
                }
                if (rects[j].top > this.viewY) {
                    return;
                }
            }
        }
    }

    /** determines whether the view X/Y is within the specified bounds */
    public inside(rect: ClientRect) {
        return this.viewX >= rect.left
            && this.viewX < rect.right
            && this.viewY >= rect.top
            && this.viewY < rect.bottom;
    }

    /** measures the bounds of a specific character */
    public boundsOfCharacter(idxCharacter: number) {
        this._textRange.moveToElementText(this.element);
        this._textRange.move('character', idxCharacter);
        this._textRange.moveEnd('character', 1);
        const rect = this._textRange.getClientRects();
        return rect;
    }

    private getCrossBrowserOffset(idxCharacter: number) {
        const ieSkipsTheseDuringMove = '\r\n';
        let cntCharacterCleaned = 0;
        for (let i = 0; i < idxCharacter; i++) {
            if (ieSkipsTheseDuringMove.indexOf(this._characters[i]) === -1) {
                cntCharacterCleaned++;
            }
        }
        return cntCharacterCleaned;
    }
}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/domop/IEInsanity.tsx